import type { IconSvgObject } from './types';

const FirstBracketIcon: IconSvgObject = [
  ["path", { d: "M6 3C3.58901 4.93486 2 8.24345 2 12C2 15.7565 3.58901 19.0651 6 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 3C20.411 4.93486 22 8.24345 22 12C22 15.7565 20.411 19.0651 18 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FirstBracketIcon;
